import { SingleProduct } from './SingleProduct';

export default SingleProduct;
